import React from 'react';

/**
 * Single continuous vertical separator for the search-highlight grid used by
 * row displays (work orders, walkthroughs). It positions itself at the right
 * edge of the grid's first (label) column by reading the live computed
 * `grid-template-columns` width, and stays in sync via a ResizeObserver.
 *
 * Must be rendered as a direct child of a `position: relative` CSS grid whose
 * first column is the label column (`gridTemplateColumns: 'auto 1fr'`).
 */
const GridColumnSeparator: React.FC = () => {
	const ref = React.useRef<HTMLDivElement | null>(null);
	React.useLayoutEffect(() => {
		const el = ref.current;
		if (!el) return;
		const grid = el.parentElement;
		if (!grid) return;
		const update = () => {
			const colWidths = window.getComputedStyle(grid).gridTemplateColumns.split(' ');
			const firstColWidth = parseFloat(colWidths[0]);
			if (!isNaN(firstColWidth)) {
				el.style.left = firstColWidth + 1 + 'px';
				el.style.visibility = firstColWidth > 0 ? 'visible' : 'hidden';
			}
		};
		update();
		const observer = new ResizeObserver(update);
		observer.observe(grid);
		return () => observer.disconnect();
	}, []);
	return <div ref={ref} className="pointer-events-none absolute inset-y-0 w-px bg-grey-5" />;
};

export default GridColumnSeparator;
